module.exports = __webpack_public_path__ + "static/6-47f40b0c29a2b1e51dca3be2c2db4074.jpeg";